import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomModal from './CustomModal';
import { useClerk } from '@clerk/clerk-react';
import './css/SettingsPage.css';

const userId = localStorage.getItem('userId');

const THEME_OPTIONS = [
  { name: "Vivid Blue", value: "#2979FF" },
  { name: "Hot Pink", value: "#FF4081" },
  { name: "Bright Orange", value: "#FF9100" },
  { name: "Electric Purple", value: "#D500F9" },
  { name: "Aqua", value: "#00E5FF" },
  { name: "Sun Yellow", value: "#FFEA00" },
  { name: "Bright Red", value: "#FF1744" },
  { name: "Turquoise", value: "#1DE9B6" },
  { name: "White", value: "#FFFFFF" },
  { name: "Black", value: "#000000" },  
];

const SettingsPage = () => {
  const navigate = useNavigate();
  const { signOut } = useClerk();

  const [shotLimit, setShotLimit] = useState("none");
  const [theme, setTheme] = useState("#1976d2");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalMessage, setModalMessage] = useState('');
  const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch('/server/crazy-cup-server/getUserSettings.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setShotLimit(data.settings.shotLimit || "none");
          setTheme(data.settings.theme || "#1976d2");
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSave = () => {
    setSaving(true);
    fetch('/server/crazy-cup-server/saveUserSettings.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        userId,
        shotLimit,
        theme
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setModalTitle('Success');
          setModalMessage('Settings saved!');
        } else {
          setModalTitle('Error');
          setModalMessage('Failed to save settings.');
        }
        setModalOpen(true);
      })
      .finally(() => setSaving(false));
  };

  if (loading) return <div className="page settings-page"><h1>Loading...</h1></div>;

  const handleModalClose = () => {
    setModalOpen(false);
    if (modalTitle === 'Success') {
      window.location.reload(); // Refresh the page
    }
  };

  const handleManageGroups = () => {
    setModalTitle('Coming Soon');
    setModalMessage('The Manage Groups feature is coming soon!');
    setModalOpen(true);
  };

  return (
    <div className="page settings-page">
      <h1 className='page-title'>Settings</h1>
      <section>
        <h3>Game Preferences</h3>
        <div>
          <label>
            Shot Limit Per Hole:
            <select value={shotLimit} onChange={e => setShotLimit(e.target.value)}>
              <option value="none">No Limit</option>
              <option value="6">6 shots</option>
              <option value="8">8 shots</option>
              <option value="10">10 shots</option>
            </select>
          </label>
        </div>
      </section>
      <section>
        <h3>Ball Colour</h3>
        <div className="theme-colour-options">
          {THEME_OPTIONS.map((color) => (
            <label key={color.value} className="theme-colour-label">
              <input
                type="radio"
                name="theme-colour"
                value={color.value}
                checked={theme === color.value}
                onChange={() => setTheme(color.value)}
              />
              <span
                className="theme-colour-circle"
                style={{ background: color.value }}
                title={color.name}
              />
            </label>
          ))}
        </div>
      </section>
      <button onClick={handleSave} disabled={saving} style={{marginTop: 16}}>
          {saving ? "Saving..." : "Save Settings"}
        </button>
      <section className='friends-actions'>
        <h3>Account</h3>
        <button onClick={handleManageGroups}>Manage Groups</button>
        <button 
          style={{ color: "red", marginBottom: "30px" }} 
          onClick={() => setShowLogoutConfirmation(true)}>
            Log Out
          </button>
        <button id="back-to-main" className="back-to-main" onClick={() => navigate('/')}>
          Back
        </button>
      </section>
      <CustomModal
        isOpen={modalOpen}
        onConfirm={handleModalClose}
        onClose={() => setModalOpen(false)}
        title={modalTitle}
        message={modalMessage}
      />
      <CustomModal
        isOpen={showLogoutConfirmation}
        onConfirm={() => signOut()}
        onClose={() => setShowLogoutConfirmation(false)}
        title="Confirm Log Out"
        message="Are you sure you want to log out?"
      />
    </div>
  );
};

export default SettingsPage;